export default function Error({ message }) {
  return (
    <div
      style={{
        color: "red",
      }}
    >
      {message}
    </div>
  );
}
